export class ScrollTo{
	init(){
		$('.scroll-to a, .features-list--about-menu a').on('click', function(e){
			e.preventDefault();
			var distElement 		= $(this).attr('href'),
					distElementTop 	= $(distElement).offset().top;
			
			$('html, body').animate({
				scrollTop: distElementTop
			}, 500);
		});

		$('body').scrollspy({ target: '#about-menu' })
	}
}